module.exports = __webpack_public_path__ + "static/media/mobileteligentip.7cade48d.svg";